import { useState } from "react";
import { Reveal } from "../../lib/motion";
import { PILLARS } from "../../lib/siteData";

export const TrustPillars = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="governance" data-testid="governance-section" className="relative py-28 lg:py-40">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 mb-16">
          <Reveal className="lg:col-span-5">
            <p className="text-[11px] uppercase tracking-[0.4em] text-es-accent mb-6">
              Trust &amp; Governance
            </p>
            <h2 className="font-serif font-light text-es-fg tracking-tight leading-[1.02] text-[clamp(2rem,5vw,4rem)]">
              Ethics built into the architecture, not bolted on.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5 lg:col-start-8 self-end">
            <p className="text-es-muted-fg leading-relaxed">
              Five pillars govern every identity, memory, permission, and interaction. Each
              is designed to protect the dignity and intentions of the individual while
              supporting the wellbeing and autonomy of the living.
            </p>
          </Reveal>
        </div>

        <div className="border-t border-es-border">
          {PILLARS.map((p, i) => {
            const isOpen = open === i;
            return (
              <div key={p.title} className="border-b border-es-border">
                <button
                  data-testid={`pillar-toggle-${i}`}
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center gap-6 py-7 lg:py-9 text-left group"
                >
                  <span className="text-[11px] tracking-[0.35em] text-es-muted-fg w-10">
                    {`0${i + 1}`}
                  </span>
                  <h3 className="flex-1 font-serif font-light text-es-fg text-[clamp(1.4rem,3vw,2.6rem)] tracking-tight group-hover:text-es-accent transition-colors duration-300">
                    {p.title}
                  </h3>
                  <span
                    className={`text-es-muted-fg text-2xl transition-transform duration-500 ${
                      isOpen ? "rotate-45" : ""
                    }`}
                  >
                    +
                  </span>
                </button>
                <div
                  className="grid transition-[grid-template-rows] duration-500 ease-[cubic-bezier(0.25,1,0.5,1)]"
                  style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                >
                  <div className="overflow-hidden">
                    <p className="pb-9 pl-16 pr-6 max-w-2xl text-es-muted-fg leading-relaxed">
                      {p.body}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-12 font-serif italic text-es-fg text-xl sm:text-2xl tracking-tight">
            Transparency is the default.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
